import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";

export class PaginationMeta {
    page = 1;
    limit = LIMIT_PAGE_DEFAULT;
    total = 0;
    totalPage = 0;
}